
$(document).on('click', '.pdp-buy-box-varieties-container[page="subscription"] .pdp-buy-box-variety', function () {
    
    var variant_id = $(this).attr('data-id');
    var handle = $(this).attr('data-handle');
    var img = $(this).attr('data-feat-img');
    var prod_name = $(this).attr('data-title');
    var color = $(this).attr('data-color');
    var prod_descr = $(this).attr('data-descr');
    var prod_descr_full = $(this).attr('data-descr-full');
    var id = $(this).attr('data-id');
    var price = $(this).attr('price');

    
    $('.lsg-reviews.active').each(function() {
      $(this).removeClass('active');
    });
    
    $('.lsg-reviews-'+id).each(function() {
      $(this).addClass('active');
    });
   
    
    $('.active-box-block').each(function(){
        $(this).addClass('inactive-box-block');
        $(this).removeClass('active-box-block');
    });

    $('.pdp-buy-box-variety').each(function(){
        $(this).removeClass('active');
      });
  
  
      $('#'+id).addClass('active-box-block');
      $('#'+id).removeClass('inactive-box-block');
  
      $(this).addClass('active');
  
    
     

    $('#product-price-'+variant_id).text(price);

    
    
    // Update Product Title
    $('#lsg-product-name h1').replaceWith('<h1>'+prod_name+'</h1>');
    $('#lsg-product-name h1').css('color',color);
    $('#lsg-reviews svg path').css('fill',color);
    
    $('#lsg-description').empty();
    $('#lsg-description').append('<div id="shortdescr"><p>'+prod_descr+'</p></div><div id="fulldescr" style="display:none">'+prod_descr_full+'</div><a id="less" style="display:none"><p>Less</p></a><a id="showfulldescr"><p>More</p></a>');

    var rechprice = $('.active-box-block [data-subs-variant='+variant_id+']').attr('data-subs-price');
    $('#product-price-recharge-'+variant_id).text(rechprice);
    // Update Hidden Input Variant ID
    $('.active-box-block .shopify-product-form').first().attr('id', "product_form_"+variant_id);

    $('.item .left .banner').attr('src', img);

    // Update Variant Buybox
    
    // Update Variant Selector
 
    $('.pdp-buy-box-varieties-header[data-handle="' + handle + '"]').addClass('current');
    $('#showfulldescr').on('click', function() {
        $(this).toggle();
        $('#less').toggle();
        $('#shortdescr').toggle();
        $('#fulldescr').toggle(); 
      });
      $('#less').on('click', function() {
        $(this).toggle();
        $('#showfulldescr').toggle();
        $('#shortdescr').toggle();
        $('#fulldescr').toggle();
      });
});





